export const NO_DELIVERY = 'Доставки нет'

export const DELIVERY_TYPES = {
    COURIER: 'courier',
    PICKUP: 'pickup',
    HALL: 'hall',
}

export const DELIVERY_TYPES_MAP = {
    courier: 'Доставка',
    pickup: process.env.isKiosk ? 'С собой' : 'Самовывоз',
    hall: 'В зале',
}

export const PAYMENT_TYPES = {
    COURIER_CASH: 'courier_cash',
    COURIER_CARD: 'courier_card',
    ONLINE: 'online',
    SBP: 'sbp',
    TERMINAL_CARD: 'terminal_card',
}

export const TOAST = {
    DURATION: 1500,
    TYPE_ERROR: 'error',
}

export const API_ERRORS = {
    STOP_LISTED: 'Товар в стоп листе',
}

export const MERCURE_TOPICS = {
    SBP_PAYMENT_SUCCESS: '/sbp/payment-success',
    KIOSK_MAINTENANCE_MODE: '/kiosk/maintenance',
}

export const KIOSK_INACTIVE_SETTINGS = {
    SUCCESS_PAGE_DELAY_MS: 30000,
    DELAY_MS: 60000,
    TIME_STEP_MS: 1000,
}

export const PROMOCODE_TYPES = {
    ABSOLUTE_VALUE: 'absoluteValue',
    PERCENT: 'percent',
    DISH_AS_GIFT: 'dishAsGift',
}

export const MOBILE_USERAGENTS = ['Android', 'iPhone']

export const TG_MINIAPP_START_PARAMS = {
    ORDER_SUCCESS: 'order-success',
}

export const MODAL_ROUTES = {
    PRODUCT: 'product/',
}

export const THEMES_WITH_MODAL_ROUTES = ['shawarma-vibe']
